<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<mat-card class="dashboard-card" [ngStyle]="{ 'background-color': color }">
  <mat-card-content>
    <div class="card-content">
      <div *ngIf="loading" class="loader" id="circle">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p i18n="{{cardContentTranslation}}" *ngIf="!loading">
        <span *ngIf="!isDate"> {{ cardContent | number : pipe }} {{ type }}</span>
        <span *ngIf="isDate">
          {{ customDateFormatService.formatDate(dateCardContent) }} {{ type }}</span
        >
      </p>
    </div>
    <div class="card-title">
      <p i18n="{{cardTitleTranslation}}">{{ cardTitle }}</p>
    </div>
  </mat-card-content>
</mat-card>
